import React, { memo, useMemo, Suspense } from "react";
import { theme } from "uikit";
import { useTranslation } from "react-i18next";

import Map, { type PolygonList } from "../../../../DispatcherMap";
import { useTypedSelector } from "../../../../../redux/store";

const ParkingsBase: React.FC<ParkingsBase.Props> = ({
	taxiServiceIds,
	taxiServiceId,
}): JSX.Element => {
	const { t } = useTranslation();

	const language = useTypedSelector((state) => state.session.language);

	const items = useTypedSelector(
		(state) => state.globalState.parking.data.subscription.basic,
	);

	const text = useMemo(
		() => t(`mainPage.archives.orders.modal.map.polygons.parking`),
		[t],
	);

	const value = useMemo<PolygonList | undefined>(() => {
		if (Array.isArray(taxiServiceIds)) {
			return items
				?.filter((item) => taxiServiceIds.includes(item?.taxiServiceId))
				?.map((parking) => ({
					id: parking.id,
					name:
						`${text} ${parking.name?.[language]}` ||
						Object.values(parking.name)?.[0],
					color: theme.colors.info,
					vertices: parking.vertices.map((v) => [v.lat, v.lng]),
					editable: false,
				}));
		}

		if (taxiServiceId) {
			return items
				?.filter((item) => item?.taxiServiceId === taxiServiceId)
				?.map((parking) => ({
					id: parking.id,
					name:
						`${text} ${parking.name?.[language]}` ||
						Object.values(parking.name)?.[0],
					color: theme.colors.info,
					vertices: parking.vertices.map((v) => [v.lat, v.lng]),
					editable: false,
				}));
		}
		return items?.map((parking) => ({
			id: parking.id,
			name:
				`${text} ${parking.name?.[language]}` ||
				Object.values(parking.name)?.[0],
			color: theme.colors.info,
			vertices: parking.vertices.map((v) => [v.lat, v.lng]),
			editable: false,
		}));
	}, [taxiServiceIds, taxiServiceId, items, text, language]);

	return (
		<Suspense>
			<Map.PolygonEditor value={value} editing={false} />
		</Suspense>
	);
};

declare namespace ParkingsBase {
	interface Props {
		taxiServiceId?: number;
		taxiServiceIds?: number[];
	}
}

const Parkings = memo(ParkingsBase);

export default Parkings;
